import WindowFloat from './WindowFloat'
import Bold from './Bold'
import { SSRGlobal } from './Context'

export default (props) => {
    let z = SSRGlobal()
    if (z.lang.code == "en") {
        return <WindowFloat title={z.lang.whyfee} onclose={() => { props.onclose?.() }}
            maxWidth="25rem" z={400} wz={500} >
            <p>
                The fees related to deposits, withdrawals, and transfers are associated with the bank, communication intermediaries, and also the
                <a>Network Expansion Project</a>.
                &nbsp;
                Payment commission details are fully and transparently visible in the transactions.
                &nbsp;
                <br-x />

                Did you know that by participating in the Network Expansion Project,
                &nbsp;
                <Bold>
                    all your fees can be completely waived
                </Bold>
                &nbsp;
                and you can even use this
                &nbsp;
                <Bold>
                    as a source of income
                </Bold>?
            </p>
            <br />

            <b-200 class={z.styles.btnaccept}  onClick={() => { props.onclose?.() }}>{z.lang.close}</b-200>
            <br-xx />
        </WindowFloat>
    }
    else if (z.lang.code == "fa") {
        return <WindowFloat title={z.lang.whyfee} onclose={() => { props.onclose?.() }}
            maxWidth="25rem" z={400} wz={500} >
            <p>
                کارمزدهای مربوط به واریز، برداشت و انتقال مربوط به بانک، واسط های ارتباطی و نیز واسط های

                <a>پروژه ی گسترش شبکه</a>
                &nbsp;
                می‌باشد
                و اطلاعات پرداخت کمیسیون ها به طور  کامل و شفاف در
                تراکنش ها قابل مشاهده میباشد.
                &nbsp;
                <br-x />

                آیا میدانستید که با شرکت کردن در پروژه گسترش شبکه،
                &nbsp;
                <Bold>
                    کارمزد های شما کاملا رایگان شده
                </Bold>
                &nbsp;
                و حتی میتوانید از این
                &nbsp;
                <Bold>
                    راه کسب در آمد
                </Bold>
                &nbsp;
                نمایید؟

            </p>
            <br />

            <b-200  class={z.styles.btnaccept} onClick={() => { props.onclose?.() }}>{z.lang.close}</b-200>
            <br-xx />
        </WindowFloat>
    }

}